
import { ObserveVisibility } from 'vue3-observe-visibility'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('thover',{
  });
  nuxtApp.vueApp.directive('observe-visibility', ObserveVisibility)
})